import React from 'react';
import {Button, Checkbox, message, Select, Radio, Icon, Row, Col } from 'antd';
import {WeaDialog, WeaSearchGroup, WeaFormItem, WeaInput, WeaSelect, WeaBrowser,
    WeaCheckbox, WeaHelpfulTip, WeaColorPicker } from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
import {WeaMaterialLib} from 'weaPortalPublic';
const getLabel = WeaLocaleProvider.getLabel;
// 快捷入口元素，数据来源
class Content_QuickEntry_DataSource extends React.Component {

    state = {
        id: this.props.tabData.id,
        title: this.props.tabData.title || '',
        picture: this.props.tabData.picture || '',
        link: this.props.tabData.link || '',
        backGroundColor: this.props.tabData.backGroundColor || '#FFFFFF',
        linkMode: 'normal',
        replaceDatas: [],
    };

    constructor(props) {
        super(props);
        this.getButtons = this.getButtons.bind(this);
        this.onOk = this.onOk.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    render() {
        const { id, title,  linkMode, picture, link, backGroundColor, replaceDatas} =  this.state;
        const colProps = {
            labelCol: {span: 6},
            wrapperCol: {span: 16}
        };

        return (
            <WeaDialog
                className="portal-quickentry-esetting-dialog"
                visible={true}
                title={getLabel(19480, '内容设置')}
                icon="icon-coms-portal"
                iconBgcolor='#1a57a0'
                style={{width: 660, height: 210}}
                hasScroll={true}
                buttons={this.getButtons()}
                onCancel={this.onCancel}
            >
                <WeaSearchGroup title={getLabel(33396, '设置项')} needTigger={true} showGroup={true}>
                    <WeaFormItem label={getLabel(24986,'标题')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaInput value={title} viewAttr = '3' onChange={value => this.setState({title: value})}/>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(515770,'快捷入口图标') } labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaMaterialLib
                            multiCheck={false}
                            value={picture}
                            isShow={true}
                            onChange={value => this.setState({picture: value})}
                        />
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(16208, '链接地址')} {...colProps}>
                        <Row gutter={8}>
                            <Col span={6}>
                                <WeaSelect
                                    options={[
                                        {key: 'normal', selected: false, showname: getLabel(385809, '自定义URL')},
                                        {key: 'advance', selected: false, showname: getLabel(33496, '系统菜单')},
                                        {key: 'advance2', selected: false, showname: getLabel(31560, '系统页面')},
                                    ]}
                                    value={linkMode}
                                    onChange={value => this.setState({linkMode: value})}
                                />
                            </Col>
                            <Col span={17}>
                                {linkMode == 'normal' ? <WeaInput value={link} onChange={value => this.setState({link: value})}/> : ''}
                                {linkMode == 'advance' ? (
                                    <WeaBrowser
                                        title={getLabel(33496, '系统菜单')}
                                        type={'portalmenu'}
                                        tabs={[
                                            {name: getLabel(33675, '前端菜单'), key: '1', dataParams: {sourcetype: '1'}, conditionDataParams: {sourcetype: '1'}},
                                            {name: getLabel(33676, '后端菜单'), key: '2', dataParams: {sourcetype: '2'}, conditionDataParams: {sourcetype: '2'}},
                                            {name: getLabel(18773, '自定义菜单'), key: '3', dataParams: {sourcetype: '3'}, conditionDataParams: {sourcetype: '3'}},
                                            {name: getLabel(23094, '系统门户页面'), key: '4', dataParams: {sourcetype: '4'}, conditionDataParams: {sourcetype: '4'}}
                                        ]}
                                        onChange={(id, name, data) => this.setState({link: data.length == '0' ? '' :data[0].fullrouteurl || data[0].linkAddress})}
                                        // onChange={(id, name, data) => this.onChange({'fullrouteurl': data.length == '0' ? '' :data[0].fullrouteurl || data[0].linkAddress, 'linkAddress': data.length == '0' ? '' : data[0].fullrouteurl || data[0].linkAddress || '', 'mobxrouteurl': ''})}
                                    />
                                ) : ''
                                }
                                {linkMode == 'advance2' ? (
                                    <WeaBrowser
                                        title={getLabel(31560, '系统页面')}
                                        type={'systempage'}
                                        isSingle={false}
                                        replaceDatas={replaceDatas}
                                        tabs={[
                                            {name: getLabel(22243, '文档'), key: '1', dataParams: {sourcetype: '1'}},
                                            {name: getLabel(30045, '流程'), key: '2', dataParams: {sourcetype: '2'}},
                                        ]}
                                        onChange={(id, name, data) =>{
                                            let menuhref = '';
                                            if(data[0].activeKey == '1'){
                                                menuhref = data[0].dropMenuUrl + id;
                                                this.setState({link: menuhref,replaceDatas: data})
                                            }else if(data[0].activeKey == '2'){
                                                let arr = id.split(',');
                                                let wftypeIds = [];
                                                let wfIds = [];
                                                arr.map((item) => {
                                                    if(item.lastIndexOf('wftype') != -1){
                                                        wftypeIds.push(item.split('wftype_').join(''));
                                                    }else{
                                                        wfIds.push(item.split('wf_').join(''));
                                                    }
                                                });
                                                data.map(item => {
                                                    if(item.allVersionIds && item.allVersionIds != '') {
                                                        const allVersionIdsArrs = item.allVersionIds.split(',');
                                                        if(allVersionIdsArrs.length > 1) {
                                                            allVersionIdsArrs.map(allVersionIdsItem => {
                                                                if(allVersionIdsItem != '') {
                                                                    wfIds.push(allVersionIdsItem);
                                                                }
                                                            })
                                                        }else {
                                                            wfIds.push(allVersionIdsArrs.join(''));
                                                        }
                                                    }
                                                })
                                                let viewType = '';
                                                if(data[0].dropMenuValue == '1'){
                                                    let jsonstr = 'wfRange=' + wfIds.toString();
                                                    menuhref = data[0].dropMenuUrl + jsonstr;
                                                    this.setState({link: menuhref,replaceDatas: data});
                                                    return;
                                                }else if(data[0].dropMenuValue == '2'){
                                                    viewType = "1";
                                                }else if(data[0].dropMenuValue == '3'){
                                                    viewType = "2";
                                                }else if(data[0].dropMenuValue == '4'){
                                                    viewType = "3";
                                                }else if(data[0].dropMenuValue == '5'){
                                                    viewType = "5";
                                                }else if(data[0].dropMenuValue == '6'){
                                                    viewType = "6";
                                                }else if(data[0].dropMenuValue == '7'){
                                                    viewType = "4";
                                                }
                                                let jsonstr = {
                                                    flowids:wfIds,
                                                    viewType:viewType,
                                                    typeids:wftypeIds,
                                                    isExclude : 0
                                                };
                                                if(viewType== '2'){
                                                    jsonstr.isArrangement =1;
                                                }else if(viewType == '1'){
                                                    jsonstr.showView =1;
                                                }
                                                menuhref = data[0].dropMenuUrl + escape(JSON.stringify(jsonstr));
                                                this.setState({link: menuhref,replaceDatas: data})
                                            }
                                        }}
                                    />
                                ) : ''
                                }
                            </Col>
                            <Col span={1}>
                                <div style={{position: 'absolute', top: '6px'}}>
                                    <WeaHelpfulTip title={getLabel('386567', '外部地址，请在地址前加上http://或https://')}/>
                                </div>
                            </Col>
                        </Row>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(83749,'背景色') } labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaColorPicker
                            value={backGroundColor}
                            onChange={(v)=> this.setState({backGroundColor: v})}
                        />
                        <WeaHelpfulTip style={{position: 'absolute',
                            top: '7px',
                            left: '110px'}} title={getLabel(516344,'仅在显示样式为有背景色时有效')}/>
                    </WeaFormItem>
                </WeaSearchGroup>
            </WeaDialog>

        );
    }

    getButtons() {
        let buttons = [];
        buttons.push(<Button type="primary" onClick={this.onOk}>{getLabel(826, '确定')}</Button>);
        buttons.push(<Button type="ghost" onClick={this.onCancel}>{getLabel(31129, '取消')}</Button>);
        return buttons;
    }

    onOk() {
        if (!this.state.title) {
            message.warning(getLabel(15859, '必要信息不完整！'));
        } else {
            this.props.onOk(this.state)
        }
    }

    onCancel() {
        this.props.onCancel();
    }
}

export default Content_QuickEntry_DataSource;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_QuickEntry_DataSource.js